import "./styles.scss";

import Button from "components/ui/button";
import Dialog from "components/ui/dialog";
import { BaIconShare2 } from "components/ui/icons";
import ShareFallback from "components/ui/share-fallback";
import { supportNativeShare } from "components/utils/device";
import { useApp } from "hooks/app";
import React, { useEffect, useState } from "react";

const ShareLinkDialog = () => {
  const { shareLinkOpen, shareLink, closeShareLink } = useApp();
  const { url, title, text, onSuccess, buttonTitle, dialogTitle, dialogSubtitle } = shareLink || {};
  const [showFallbackDialog, setShowFallbackDialog] = useState(false);

  useEffect(() => {
    if (url) {
      if (supportNativeShare) {
        triggerNativeShare({ url, title, text });
      } else {
        setShowFallbackDialog(true);
      }
    }
  }, [url]);

  const triggerNativeShare = async (shareData) => {
    try {
      // eslint-disable-next-line no-undef
      await navigator.share(shareData);
      closeShareLink();
    } catch (err) {
      setShowFallbackDialog(true);
    }
  };

  const onCloseFallback = () => {
    setShowFallbackDialog(false);
    closeShareLink();
  };

  if (!url) {
    return null;
  }

  return (
    <Dialog open={shareLinkOpen && showFallbackDialog} title={dialogTitle} subtitle={dialogSubtitle} onClose={onCloseFallback}>
      {supportNativeShare ? (
        <Button onClick={() => triggerNativeShare({ url, title, text })} style={{ marginBottom: "2rem" }} startIcon={<BaIconShare2 />}>
          SHARE NOW
        </Button>
      ) : (
        <ShareFallback onSuccess={onSuccess} title={title} text={text} url={url} buttonTitle={buttonTitle} />
      )}
    </Dialog>
  );
};

export default ShareLinkDialog;
